<template>
  <button
    type="button"
    @click="copy"
    :title="tooltip || $t('copyLink')"
    :class="
      variant === 'outline'
        ? 'btn gap-2 !px-4 !rounded-lg bg-white border text-primary border-primary'
        : 'flex items-center justify-center w-full h-full gap-2 p-3 text-sm bg-dark200 text-dark800'
    "
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
    </svg>
    <span>{{ $t("copyLink") }}</span>
  </button>
</template>

<script setup lang="ts">
import { useToast } from "vue-toastification";
import { useI18n } from "vue-i18n";

const props = withDefaults(
  defineProps<{
    link: string;
    variant?: "strip" | "outline";
    tooltip?: string;
  }>(),
  { variant: "strip" }
);

const toast = useToast();
const { t } = useI18n();

const copy = async () => {
  try {
    await navigator.clipboard.writeText(props.link);
    toast.success(t("linkCopied"));
  } catch {
    toast.error(t("linkCopyFailed"));
  }
};
</script>
